// extracted by mini-css-extract-plugin
export default {"container":"profile_container__RQTrw","formwrapper":"profile_formwrapper__UYbEA","personalDetails":"profile_personalDetails__MVTvV"};